module.exports = __webpack_public_path__ + "static/media/CT_2019_30440_9301_pdf.c218145f.pdf";